import React from 'react'
import DefaultForm from '../../../ui/forms/default-form'
import { DeviceRegistrationFields } from './views/fields'

const apiEndPoint = org_id => process.env.REACT_APP_API_HOST + `/api/device-registrations/${org_id}`

export const validate = ({ device_name, one_time_access_token }) =>
  device_name && (one_time_access_token && one_time_access_token.match(/\w{10}/))

const DeviceRegistration = ({ organisation_id, onComplete }) => (
  <DefaultForm
    url={apiEndPoint(organisation_id)}
    name="deviceRegistration"
    label="Register Device"
    loadingTitle="Registering B2B device"
    handleSuccess={onComplete}
    formComponent={DeviceRegistrationFields}
    formOptions={{
      validate,
    }}
  />
)

export default DeviceRegistration



// WEBPACK FOOTER //
// ./src/providers-registrations/onboarding/device-registration/container.jsx